package org.example.project.viewmodel

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import kotlinx.coroutines.flow.collect
import kotlinx.coroutines.launch
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.delay
import org.example.project.firebase.AuthManager
import org.example.project.firebase.FirestoreManager

class AuthViewModel {

    var authReady by mutableStateOf(false)
        private set

    var loggedIn by mutableStateOf(false)
        private set

    var errorMessage by mutableStateOf<String?>(null)
        private set

    var isLoading by mutableStateOf(false)
        private set

    private val scope = MainScope()

    private val viewModel=GameViewModel()

    init {
        scope.launch {
            AuthManager.authStateChanged.collect { user ->
                loggedIn = user != null
                authReady = true
            }
        }
    }

    fun loginWithGitHub() {
        scope.launch {
            isLoading = true
            errorMessage = null

            val githubInfo = AuthManager.loginWithGitHub()
            if (githubInfo == null) {
                errorMessage = "GitHub login failed. Please try again."
                isLoading = false
                return@launch
            }

            if (githubInfo.username.isBlank() ||
                githubInfo.photoUrl.isBlank()) {

                println("GitHub profile incomplete, retrying...")

                delay(1000)

                val retry = AuthManager.loginWithGitHub()

                if (retry == null ||
                    retry.username.isBlank() ||
                    retry.photoUrl.isBlank()) {

                    errorMessage =
                        "Could not fetch GitHub profile."

                    isLoading = false
                    return@launch
                }
            }

            val uid = AuthManager.waitForUserId()
            if (uid == null) {
                errorMessage = "Login failed. Please try again."
                isLoading = false
                return@launch
            }

            AuthManager.waitForAuthToken()
            val email = AuthManager.currentUserEmail() ?: ""
            
            println("Creating/updating user profile with GitHub data: username=${githubInfo.username}, photoUrl=${githubInfo.photoUrl}")
            FirestoreManager.ensureUserProfile(
                uid = uid,
                email = email,
                username = githubInfo.username,
                photoUrl = githubInfo.photoUrl
            )

            kotlinx.coroutines.delay(500)
            
            println("Setting user online")
            FirestoreManager.setOnline(uid, true)

            isLoading = false
        }
    }

    fun logout() {
        scope.launch {
            AuthManager.currentUserId()?.let { uid ->
                FirestoreManager.setOnline(uid, false)
            }
            AuthManager.logout()
        }
    }
}
